module.exports = __webpack_public_path__ + "static/media/Ash.174093b1.jpg";